import React from "react";
import styles from "./index.module.scss";
import { Switch } from "antd";
import BlessSwitch from "@/components/layout/switch";
import { useBridgeScannerStore } from "@/features/bridge-scanner/stores/bridge-scanner.store";
import classNames from "classnames";
import { BiLoader } from "react-icons/bi";

type Props = {};

const TableSwitchLiveMode = (props: Props) => {
  const { liveMode, setLiveMode } = useBridgeScannerStore();

  const handleLiveModeSwitch = () => {
    setLiveMode(!liveMode);
  };

  return (
    <div className={styles.liveModeToggleContainer}>
      <span className={classNames(styles.text, liveMode && styles.active)}>
        LIVE MODE
      </span>
      <Switch checked={liveMode} onChange={handleLiveModeSwitch} />
      {liveMode && (
        <div className={styles.loaderWrapper}>
          <div className={styles.loader} />
        </div>
      )}
    </div>
  );
};

export default TableSwitchLiveMode;
